
var stock_canvas, stock_stage;

var canvas, stage;
var mouseTarget;
var update = true;
var image;

//var button_image_file = "buttons_niner.png";
//var tener_button_image_file = "buttons_tener.png";

var drum_image;
var button_image;
var tener_button_image;

var showing_custom_scale = false;
var custom_scale1_potition = -1;
var custom_scale2_potition = -1;
var prior_custom_scale_note = "A2";

var drum_type = 9;

var price = 250;
var drum_cost = 250;

var options_price = 0;

var using_pattern = 0;
//var drum_image_path = "https://steeltonguedrums.com/images/vdrum/";
var drum_image_path = "/images/vdrum/";


var audioPath = "";//"../wp-content/themes/Yeahcan-Responsive/music/notes/";


var hit_with = "F";

var tuning = "440hz";
var pickup_system = false;
var dampening_pads = false;


/*var drum_notes = [ 
	"A2", "B2", "C2", "D2", "E2", "F2", "G2", 
	"Ab2", "Bb2", "Db2", "Eb2", "Gb2", 
	"A3", "B3", "C3", "D3", "E3", "F3", "G3", 
	"Ab3", "Bb3", "Db3", "Eb3", "Gb3",
	"C4", "D4"
];*/


// If you edit order of this array, edit drum_notes_files and drum_notes_m_files too!!
var drum_notes = [ 
	"C2", "Db2", "D2", "Eb2", "E2", "F2", "Gb2", "G2", "Ab2", "A2", "Bb2", "B2", 
  "C3", "Db3", "D3", "Eb3", "E3", "F3", "Gb3", "G3", "Ab3", "A3", "Bb3", "B3",   
	"C4", "D4"
];


var drum_notes_files = [
  "//manastonedrums.com/cdn/shop/t/17/assets/C2.mp3?v=95210709245325506851765972515",
  "//manastonedrums.com/cdn/shop/t/17/assets/Db2.mp3?v=95551687511488582651765972515",
  "//manastonedrums.com/cdn/shop/t/17/assets/D2.mp3?v=35414139016806323751765972515",
  "//manastonedrums.com/cdn/shop/t/17/assets/Eb2.mp3?v=162619312811028099311765972515",
  "//manastonedrums.com/cdn/shop/t/17/assets/E2.mp3?v=18132998971560304451765972515",
  "//manastonedrums.com/cdn/shop/t/17/assets/F2.mp3?v=103800021737247221051765972515",
  "//manastonedrums.com/cdn/shop/t/17/assets/Gb2.mp3?v=52322945865977910901765972516",
  "//manastonedrums.com/cdn/shop/t/17/assets/G2.mp3?v=110309102702074408411765972515",
  "//manastonedrums.com/cdn/shop/t/17/assets/Ab2.mp3?v=117532314958599355891765972514",
  "//manastonedrums.com/cdn/shop/t/17/assets/A2.mp3?v=167231804045328153861765972514",
  "//manastonedrums.com/cdn/shop/t/17/assets/Bb2.mp3?v=16894277100583519421765972515",
  "//manastonedrums.com/cdn/shop/t/17/assets/B2.mp3?v=34919164962410775111765972515",
  "//manastonedrums.com/cdn/shop/t/17/assets/C3.mp3?v=15967975478359031481765972515",
  "//manastonedrums.com/cdn/shop/t/17/assets/Db3.mp3?v=25690987109556540611765972515",
  "//manastonedrums.com/cdn/shop/t/17/assets/D3.mp3?v=22655885121246804501765972515",
  "//manastonedrums.com/cdn/shop/t/17/assets/Eb3.mp3?v=1816591829790542451765972515",
  "//manastonedrums.com/cdn/shop/t/17/assets/E3.mp3?v=113157646798161645901765972515",
  "//manastonedrums.com/cdn/shop/t/17/assets/F3.mp3?v=26816726991929805931765972515",
  "//manastonedrums.com/cdn/shop/t/17/assets/Gb3.mp3?v=36010868228105836471765972516",
  "//manastonedrums.com/cdn/shop/t/17/assets/G3.mp3?v=182238189273654153441765972515",
  "//manastonedrums.com/cdn/shop/t/17/assets/Ab3.mp3?v=110162668318584674341765972514",
  "//manastonedrums.com/cdn/shop/t/17/assets/A3.mp3?v=75214576191980989661765972514",
  "//manastonedrums.com/cdn/shop/t/17/assets/Bb3.mp3?v=55912854359028846491765972515",
  "//manastonedrums.com/cdn/shop/t/17/assets/B3.mp3?v=97174555801382359261765972515",
  "//manastonedrums.com/cdn/shop/t/17/assets/C4.mp3?v=20344991978680738541765972515",
  "//manastonedrums.com/cdn/shop/t/17/assets/D4.mp3?v=62412824189478692311765972515"
];

var drum_notes_m_files = [
  "//manastonedrums.com/cdn/shop/t/17/assets/C2M.mp3?v=75171858178669672831765972515",
  "//manastonedrums.com/cdn/shop/t/17/assets/Db2M.mp3?v=167716104483367956611765972515",
  "//manastonedrums.com/cdn/shop/t/17/assets/D2M.mp3?v=105533491348461319581765972515",
  "//manastonedrums.com/cdn/shop/t/17/assets/Eb2M.mp3?v=3543272316254293371765972515",
  "//manastonedrums.com/cdn/shop/t/17/assets/E2M.mp3?v=159671491649822729041765972515",
  "//manastonedrums.com/cdn/shop/t/17/assets/F2M.mp3?v=74613047094401968151765972515",
  "//manastonedrums.com/cdn/shop/t/17/assets/Gb2M.mp3?v=155262057983468289661765972516",
  "//manastonedrums.com/cdn/shop/t/17/assets/G2M.mp3?v=104268736188888691781765972515",
  "//manastonedrums.com/cdn/shop/t/17/assets/Ab2M.mp3?v=14436630511146114781765972514",
  "//manastonedrums.com/cdn/shop/t/17/assets/A2M.mp3?v=4616557677964845231765972514",
  "//manastonedrums.com/cdn/shop/t/17/assets/Bb2M.mp3?v=151008656033070916511765972515",
  "//manastonedrums.com/cdn/shop/t/17/assets/B2M.mp3?v=75237945394034044021765972515",
  "//manastonedrums.com/cdn/shop/t/17/assets/C3M.mp3?v=168558876431834823721765972515",
  "//manastonedrums.com/cdn/shop/t/17/assets/Db3M.mp3?v=115048400510643346801765972515",
  "//manastonedrums.com/cdn/shop/t/17/assets/D3M.mp3?v=97728851530888665881765972515",
  "//manastonedrums.com/cdn/shop/t/17/assets/Eb3M.mp3?v=160872722210978907671765972515",
  "//manastonedrums.com/cdn/shop/t/17/assets/E3M.mp3?v=109193419469105115361765972515",
  "//manastonedrums.com/cdn/shop/t/17/assets/F3M.mp3?v=42237533947048586971765972515",
  "//manastonedrums.com/cdn/shop/t/17/assets/Gb3M.mp3?v=46191494661597725031765972516",
  "//manastonedrums.com/cdn/shop/t/17/assets/G3M.mp3?v=67810911701521811121765972516",
  "//manastonedrums.com/cdn/shop/t/17/assets/Ab3M.mp3?v=32432683452699623141765972515",
  "//manastonedrums.com/cdn/shop/t/17/assets/A3M.mp3?v=144295122560683206161765972514",
  "//manastonedrums.com/cdn/shop/t/17/assets/Bb3M.mp3?v=149624756119478697161765972515",
  "//manastonedrums.com/cdn/shop/t/17/assets/B3M.mp3?v=107024759763656916981765972515",
  "//manastonedrums.com/cdn/shop/t/17/assets/C4M.mp3?v=26440236967350201511765972515",
  "//manastonedrums.com/cdn/shop/t/17/assets/D4M.mp3?v=121551630053955945091765972515"
];


var niner_images = [];
var tener_images = [];

var scale_display_text = [];




var drum_note_positions = [ 
	[290, 254], 
	[284, 464], [95, 278], [476, 285], 
	[132, 429], [437, 430], [132, 138], 
	[443, 148], [237, 79], [343, 82]
];


var smallDrum = true;
var windowWidth = window.innerWidth;
if(windowWidth > 600){
  smallDrum = false;
}

//console.log("Screen width : ", windowWidth);

window.onresize = function() {
  var windowWidth = window.document.body.clientWidth;
  //console.log("Screen resize : ", screen.width);  
  var oldSmallDrum = smallDrum;
  if(windowWidth > 600){
  	smallDrum = false;
  }else{
    smallDrum = true;
  }
  
  if(oldSmallDrum != smallDrum){
   location.reload(); 
  }
  
}

//console.log("Screen size : ", screen.width);  


window.onkeydown = function(e) {
	//Later make it so it uses e.keycode and not key.ispressed
	
	var kc = e.keyCode;
	
	if( kc >= 49 && kc <= 57 ) {
		keyboard_drum_note( kc - 49 );
		
	}
	
	if( kc >= 97 && kc <= 105 ) {
		e.preventDefault();
		keyboard_drum_note( kc - 97 );
		return false;
	}
	
	if ( kc == 48 || kc == 96) {
		e.preventDefault();
		keyboard_drum_note(9);
		return false;
	}
	
	// Spacebar
    if( kc == 32 && e.target == document.body ) { 
        e.preventDefault();
		createjs.Sound.stop();
        return false;
    }
};

// [[xMinimum, xMaximum, yMinimum, yMaximum]]
var niner_coordinates = [
	[ 230, 363, 397, 570 ], [ 38, 194, 232, 363 ], [ 411, 564, 242, 363 ], 
	[ 62, 214, 378, 525 ], [ 385, 528, 378, 515 ], [ 68, 202, 80, 217 ], 
	[ 394, 526, 90, 222 ], [ 198, 298, 29, 152 ], [ 314, 412, 40, 148 ]
];

function get_date_ms() {
	var this_date = new Date();
	return this_date.getTime();
}
var stopper = get_date_ms();
var new_stop = 0;
var keyboard_sound_delay = 200; // in ms
var sound_stops = [
	stopper, stopper, stopper, stopper, stopper, stopper, stopper, stopper, stopper, stopper
];

var stock_drum=false;

/* old scales
var scale_notes = [
	["Db2", "Gb2", "Ab2", "B2", "Db3", "Eb3", "E3", "Gb3", "Ab3"],
	["D2", "G2", "A2", "C3", "D3", "E3", "F3", "G3", "A3"],
	["Eb2", "Ab2", "Bb2", "Db3", "Eb3", "F3", "Gb3", "Ab3", "Bb3"],
	["E2", "A2", "B2", "D3", "E3", "Gb3", "G3", "A3", "B3"],
	["F2", "Bb2", "C3", "Eb3", "F3", "G3", "Ab3", "Bb3", "C4"],
	["Db2", "F2", "Gb2", "Ab2", "Bb2", "C3", "Db3", "Eb3", "F3"],
	["Db2", "Gb2", "Ab2", "A2", "Db3", "E3", "Gb3", "Ab3", "A3", "B3"],
	["E2", "A2", "B2", "C3", "E3", "F3", "A3", "B3", "C4"],
	["Eb2", "Bb2", "B2", "D3", "Eb3", "F3", "Gb3", "Ab3", "Bb3"],
	["Eb2", "G2", "Ab2", "Bb2", "D3", "Eb3", "G3", "Ab3", "Bb3"],
	["Eb2", "F2", "Ab2", "Bb2", "C3", "Eb3", "F3", "Ab3", "Bb3"],
	["E2", "Ab2", "B2", "D3", "E3", "F3", "Ab3", "A3", "B3"],
	["F2", "Bb2", "C3", "Eb3", "F3", "G3", "A3", "Bb3", "C4"],
	["E2", "A2", "B2", "D3", "E3", "Gb3", "Ab3", "A3", "B3"],
	["F2", "A2", "Bb2", "C3", "D3", "E3", "F3", "G3", "A3"],
	["G2", "Bb2", "C3", "Db3", "E3", "F3", "G3", "Ab3", "Bb3"],
	["E2", "G2", "A2", "B2", "D3", "E3", "G3", "A3", "B3"],
	["?", "?", "?", "?", "?", "?", "?", "?", "?"],
	["?", "?", "?", "?", "?", "?", "?", "?", "?"],
  	["D2", "Gb2", "G2", "A2", "B2", "Db3", "D3", "E3", "Gb3"]
];

*/

/*var scale_notes = [
    ["F2", "Bb2", "C3", "Eb3", "F3", "G3", "A3", "Bb3", "C4"], //F Mixotonic Scale
  	["F2", "Bb2", "C3", "Eb3", "F3", "G3", "Ab3", "Bb3", "C4"], //F Big Bear Scale
	["F2", "A2", "Bb2", "C3", "D3", "E3", "F3", "G3", "A3"], //F Peace Scale
	["E2", "A2", "B2", "D3", "E3", "Gb3", "G3", "A3", "B3"],//E Big Bear Scale
    ["E2", "A2", "B2", "D3", "E3", "Gb3", "Ab3", "A3", "B3"],//E Mixotonic Scale
	["E2", "A2", "B2", "C3", "E3", "F3", "A3", "B3", "C4"], //E AkeBono Scale
	["E2", "Ab2", "B2", "D3", "E3", "F3", "Ab3", "A3", "B3"], //E Phrygian Dominant
	["E2", "G2", "A2", "B2", "D3", "E3", "G3", "A3", "B3"], //E Minor Pentatonic
	["Eb2", "Ab2", "Bb2", "Db3", "Eb3", "F3", "Gb3", "Ab3", "Bb3"],//Eb Big Bear Scale
	["Eb2", "Bb2", "B2", "D3", "Eb3", "F3", "Gb3", "Ab3", "Bb3"],//Eb Hijaz Scale
  	["Eb2", "G2", "Bb2", "C3", "D3", "Eb3", "F3", "G3", "Bb3"],//Eb Melog Scale
	["Eb2", "F2", "Ab2", "Bb2", "C3", "Eb3", "F3", "Ab3", "Bb3"],//Eb N'goni Scale
	["G2", "Bb2", "C3", "Db3", "E3", "F3", "G3", "Ab3", "Bb3"],//Spanish Gypsy 
	["D2", "G2", "A2", "C3", "D3", "E3", "F3", "G3", "A3"],//D Big Bear Scale
  	["D2", "Gb2", "G2", "A2", "B2", "Db3", "D3", "E3", "Gb3"],//D Peace Scale
	["?", "?", "?", "?", "?", "?", "?", "?", "?"], //Custom
	["?", "?", "?", "?", "?", "?", "?", "?", "?"], //Custom
    ["D2", "Gb2", "A2", "B2", "Db3", "D3", "E3", "Gb3", "A3"], //D Melog Scale
  	["E2", "Ab2", "A2", "B2", "Db3", "Eb3", "E3", "Gb3", "Ab3"], //E Peace scale
  	["F2","G2","Bb2","C3","D3","F3","G3","Bb3","C4"], //F N'goni 9-note
  	["Eb2", "G2", "Bb2", "D3", "Eb3", "F3", "G3", "A3", "Bb3"],  //Eb Lyanna
    ["F2","Ab2","Bb2","C3","Eb3","F3","Ab3","Bb3","C4"], //F minor Pentatonic
    ["F2","G2","A2","C3","D3","F3","G3","A3","C4"], //F Major Pentatonic
    ["E2","Gb2","Ab2","B2","Db3","E3","Gb3","Ab3","B3"], //E Major Pentatonic
    ["Eb2","Gb2","Ab2","Bb2","Db3","Eb3","Gb3","Ab3","Bb3"], //Eb minor Pentatonic
    ["Eb2","F2","G2","Bb2","C3","Eb3","F3","G3","Bb3"], //Eb Major Pentatonic
    ["D2","E2","Gb2","A2","B2","D3","E3","Gb3","A3"], //D Major Pentatonic
    ["D2","F2","G2","A2","C3","D3","F3","G3","A3"], //D minor Pentatonic
    ["Eb2","F2","Ab2","Bb2","Db3","Eb3","F3","Ab3","Bb3"], //Db Major Pentatonic
    ["E2","Gb2","Ab2","B2","Db3","E3","Gb3","Ab3","B3"], //Db minor Pentatonic
    ["D2","E2","G2","A2","C3","D3","E3","G3","A3"], //C Major Pentatonic
    ["Eb2","F2","G2","Bb2","C3","Eb3","F3","G3","Bb3"], //C minor Pentatonic
    ["Eb2","Gb2","Ab2","B2","Db3","Eb3","Gb3","Ab3","B3"], //B Major Pentatonic
    ["D2","E2","Gb2","A2","B2","D3","E3","Gb3","A3"], //B minor Pentatonic
    ["D2","F2","G2","Bb2","C3","D3","F3","G3","Bb3"], //Bb Major Pentatonic
    ["Eb2","F2","Ab2","Bb2","Db3","Eb3","F3","Ab3","Bb3"], //Bb minor Pentatonic
    ["E2","Gb2","A2","B2","Db3","E3","Gb3","A3","B3"], //A Major Pentatonic
    ["D2","E2","G2","A2","C3","D3","E3","G3","A3"], //A minor Pentatonic
    ["Eb2","F2","Ab2","Bb2","C3","Eb3","F3","Ab3","Bb3"], //Ab Major Pentatonic
    ["Eb2","Gb2","Ab2","B2","Db3","Eb3","Gb3","Ab3","B3"], //Ab minor Pentatonic
    ["D2","E2","G2","A2","B2","D3","E3","G3","A3"], //G Major Pentatonic 
    ["D2","F2","G2","Bb2","C3","D3","F3","G3","Bb3"], //G minor Pentatonic
    ["Eb2","Gb2","Ab2","Bb2","Db3","Eb3","Gb3","Ab3","Bb3"], //Gb Major Pentatonic
    ["E2","Gb2","A2","B2","Db3","E3","Gb3","A3","B3"], //Gb minor Pentatonic
  	["E2","Gb2","A2","B2","Db3","E3","Gb3","A3","B3"], //E N'Goni
  	["D2","E2","G2","A2","B2","D3","E3","G3","A3"],//D N'Goni
  	["F2","A2","C3","E3","F3","G3","A3","B3","C4"], //F Lyanna 9-note
  	["E2","Ab2","B2","Eb3","E3","Gb3","Ab3","Bb3","B3"],//E Lyanna 9-note
  	["D2","Gb2","A2","Db3","D3","E3","Gb3","Ab3","A3"],//D Lyanna
  	["E2","Ab2","B2","Db3","Eb3","E3","Gb3","Ab3","B3"],//E Melog
  	["F2","A2","C3","D3","E3","F3","G3","A3","C4"],//F Melog
  	["Eb2","G2","Ab2","Bb2","C3","D3","Eb3","F3","G3"],//Eb Peace
  	["Eb2","Ab2","Bb2","Db3","Eb3","F3","G3","Ab3","Bb3"],//Eb Mixotonic
  	["D2","G2","A2","C3","D3","E3","Gb3","G3","A3"], //D Mixotonic
];*/

var scale_notes = [

	["F2", "Bb2", "C3", "Eb3", "F3", "G3", "A3", "Bb3", "C4"], //F Mixotonic Scale
["F2", "Bb2", "C3", "Eb3", "F3", "G3", "Ab3", "Bb3", "C4"], //F Big Bear Scale
["F2", "A2", "Bb2", "C3", "D3", "E3", "F3", "G3", "A3"], //F Peace Scale
["E2", "A2", "B2", "D3", "E3", "Gb3", "G3", "A3", "B3"],//E Big Bear Scale
["E2", "A2", "B2", "D3", "E3", "Gb3", "Ab3", "A3", "B3"],//E Mixotonic Scale
["E2", "A2", "B2", "C3", "E3", "F3", "A3", "B3", "C4"], //E AkeBono Scale
["E2", "Ab2", "B2", "D3", "E3", "F3", "Ab3", "A3", "B3"], //E Phrygian Dominant
["E2", "G2", "A2", "B2", "D3", "E3", "G3", "A3", "B3"], //E Minor Pentatonic
["G2", "Bb2", "C3", "Db3", "E3", "F3", "G3", "Ab3", "Bb3"],//Spanish Gypsy
["E2", "Ab2", "A2", "B2", "Db3", "Eb3", "E3", "Gb3", "Ab3"], //E Peace scale
["F2","G2","Bb2","C3","D3","F3","G3","Bb3","C4"], //F N'goni 9-note
["F2","Ab2","Bb2","C3","Eb3","F3","Ab3","Bb3","C4"], //F minor Pentatonic
["F2","G2","A2","C3","D3","F3","G3","A3","C4"], //F Major Pentatonic
["E2","Gb2","Ab2","B2","Db3","E3","Gb3","Ab3","B3"], //E Major Pentatonic
["E2","Gb2","Ab2","B2","Db3","E3","Gb3","Ab3","B3"], //Db minor Pentatonic
["E2","Gb2","A2","B2","Db3","E3","Gb3","A3","B3"], //A Major Pentatonic
["E2","Gb2","A2","B2","Db3","E3","Gb3","A3","B3"], //Gb minor Pentatonic
["E2","Gb2","A2","B2","Db3","E3","Gb3","A3","B3"], //E N'Goni
["F2","A2","C3","E3","F3","G3","A3","B3","C4"], //F Lyanna 9-note
["E2","Ab2","B2","Eb3","E3","Gb3","Ab3","Bb3","B3"],//E Lyanna 9-note
["E2","Ab2","B2","Db3","Eb3","E3","Gb3","Ab3","B3"],//E Melog
["F2","A2","C3","D3","E3","F3","G3","A3","C4"],//F Melog
["G2", "C3", "D3", "E3", "F3", "G3", "A3", "B3", "C4"], //C Major Scale (kids drum)
["G2", "Bb2", "C3", "Db3", "E3", "F3", "G3", "Ab3", "Bb3"], //G Spanish Gypsy
["G2", "C3", "D3", "F3", "G3", "A3", "Bb3", "C4", "D4"], //G Big Bear
["G2", "C3", "D3", "F3", "G3", "A3", "B3", "C4", "D4"], //G Mixotonic
["G2", "A2", "B2", "D3", "E3", "G3", "A3", "B3", "D4"], //G Major Pentatonic
["G2", "Ab2", "C3", "D3", "F3", "G3", "Bb3", "C4", "D4"], //G Minor Pentatonic
["G2", "A2", "C3", "D3", "E3", "G3", "A3", "C4", "D4"], //A Minor Pentatonic
["Gb2", "A2", "B2", "D3", "E3", "Gb3", "A3", "B3", "D4"], //D Major Pentatonic
["G2", "A2", "C3", "D3", "F3", "G3", "A3", "C4", "D4"], //D Minor Pentatonic
["E2", "A2", "B2", "C3", "E3", "G3", "A3", "B3", "C4"], //E Pygmy
["E2", "B2", "E3", "Gb3", "G3", "A3", "B3", "Db4", "D4"], //E Aeolian
["Eb2", "Bb2", "B2", "D3", "Eb3", "F3", "Gb3", "Ab3", "Bb3"],//Eb Hijaz Scale


];


/* old scales
var tener_scale_notes = [
	["D2", "A2", "D3", "E3", "F3", "G3", "A3", "Bb3", "C4", "D4"],
	["D2", "A2", "Bb2", "C3", "D3", "E3", "F3", "G3", "A3", "C4"],
	["B", "Db", "Gb", "Ab", "A", "Db", "E", "Gb", "Ab", "A"]
];
*/
var tener_scale_notes = [
	["D2", "G2", "A2", "Bb2", "D3", "F3", "G3", "A3", "Bb3", "C4"], //D Super Pygmy Scale
    ["D2", "A2", "Bb2", "C3", "D3", "E3", "F3", "G3", "A3", "C4"], //D Kurd 10 Scale
    ["D2", "A2", "D3", "E3", "F3", "G3", "A3", "Bb3", "C4", "D4"] //D Aeolian Scale
];
/*
var scale_names = [
  "F Mixotonic Scale", 	// 0
  "F Big Bear Scale",  	// 1
  "F Peace Scale",		// 2	
  "E Big Bear Scale",	// 3
  "E Mixotonic Scale",	// 4
  "E AkeBono Scale",	// 5
  "E Phrygian Dominant",// 6
  "E Minor Pentatonic", // 7
  "Eb Big Bear Scale",	// 8
  "Eb Hijaz Scale",		// 9
  "Eb Melog Scale",		// 10
  "Eb N'goni Scale",	// 11
  "Spanish Gypsy",		// 12
  "D Big Bear Scale",	// 13
  "D Peace Scale",		// 14
  "Custom Scale",		// 15
  "Custom Scale Two",	// 16
  "D Melog Scale",		// 17
  "E Peace scale",		// 18
  "F N'Goni",			// 19
  "Eb Lyanna",			// 20
  "F minor Pentatonic", // 21
  "F Major Pentatonic", // 22
  "E Major Pentatonic", // 23
  "Eb minor Pentatonic",// 24
  "Eb Major Pentatonic",// 25
  "D Major Pentatonic", // 26
  "D minor Pentatonic", // 27
  "Db Major Pentatonic",// 28
  "Db minor Pentatonic",// 29
  "C Major Pentatonic", // 30
  "C minor Pentatonic", // 31
  "B Major Pentatonic", // 32
  "B minor Pentatonic", // 33
  "Bb Major Pentatonic",// 34
  "Bb minor Pentatonic",// 35
  "A Major Pentatonic", // 36
  "A minor Pentatonic", // 37
  "Ab Major Pentatonic",// 38
  "Ab minor Pentatonic",// 39
  "G Major Pentatonic", // 40
  "G minor Pentatonic", // 41
  "Gb Major Pentatonic",// 42
  "Gb minor Pentatonic",// 43
  "E N'Goni",			// 44
  "D N'Goni",			// 45
  "F Lyanna 9-note",	// 46
  "E Lyanna 9-note",	// 47
  "D Lyanna",			// 48
  "E Melog",			// 49
  "F Melog",			// 50
  "Eb Peace",			// 51
  "Eb Mixotonic",		// 52
  "D Mixotonic",		// 53
  
];
*/

var scale_names = [
  "F Mixotonic Scale",    // 0
  "F Big Bear Scale",     // 1
  "F Peace Scale",        // 2
  "E Big Bear Scale",     // 3
  "E Mixotonic Scale",    // 4
  "E AkeBono Scale",      // 5
  "E Phrygian Dominant",  // 6
  "E Minor Pentatonic",   // 7
  "Spanish Gypsy",        // 8
  "E Peace scale",        // 9
  "F N'Goni",             // 10
  "F minor Pentatonic",   // 11
  "F Major Pentatonic",   // 12
  "E Major Pentatonic",   // 13
  "Db minor Pentatonic",  // 14
  "A Major Pentatonic",   // 15
  "Gb minor Pentatonic",  // 16
  "E N'Goni",             // 17
  "F Lyanna 9-note",      // 18
  "E Lyanna 9-note",      // 19
  "E Melog",              // 20
  "F Melog",              // 21
  "C Major Scale",        // 22
  "G Spanish Gypsy",      // 23
  "G Big Bear",           // 24
  "G Mixotonic",          // 25
  "G Major Pentatonic",   // 26
  "G minor Pentatonic",   // 27
  "A minor Pentatonic",   // 28
  "D Major Pentatonic",   // 29
  "D minor Pentatonic",   // 30
  "E Pygmy",              // 31
  "E Aeolian",            // 32
  "Eb Hijaz Scale",       // 33
  "Custom Scale",       // 34
];

var tener_scale_names = [
	"D Super Pygmy Scale",
	"D Kurd 10 Scale",
	"D Aeolian Scale"
];

var finish_names = [
	"Hot Rod Black",
	"Silver Vein",
	"Copper Vein",
	"Chameleon Sapphire Prismatic",
	"Silver/Copper",
	"Black/Copper",
	"Black/Silver"
];

/*
var scale_product_links = [   
"https://manastonedrums.com/collections/9-note-classics/products/f-mixotonic", //	F Mixotonic Scale  - 0
"https://manastonedrums.com/collections/9-note-classics/products/f-big-bear", //	F Big Bear Scale
"https://manastonedrums.com/collections/9-note-classics/products/f-peace", //	F Peace Scale
"https://manastonedrums.com/collections/9-note-classics/products/e-big-bear-manastone-steel-tongue-drum", //	E Big Bear Scale
"https://manastonedrums.com/collections/9-note-classics/products/e-mixotonic-manastone-steel-tongue-drum", //	E Mixotonic Scale
"https://manastonedrums.com/collections/9-note-classics/products/e-akebono-9-note-steel-tongue-drum", //	E AkeBono Scale
"https://manastonedrums.com/collections/9-note-classics/products/e-phrygian-dominant-manastone-steel-tongue-drum", //	E Phrygian Dominant
"https://manastonedrums.com/collections/9-note-classics/products/e-minor-pentatonic-manastone-steel-tongue-drum", // 	E Minor Pentatonic
"https://manastonedrums.com/products/e-flat-big-bear-manastone-steel-tongue-drum", //	Eb Big Bear Scale
"https://manastonedrums.com/collections/9-note-classics/products/eb-hijaz", //	Eb Hijaz Scale
"https://manastonedrums.com/collections/9-note-classics/products/copy-of-e-big-bear-manastone-steel-tongue-drum", //	Eb Melog Scale
"https://manastonedrums.com/collections/9-note-classics/products/eb-ngoni-manastone-steel-tongue-drum",//	Eb N'goni Scale
"https://manastonedrums.com/collections/9-note-classics/products/spanish-gypsy", //	Spanish Gypsy 
"https://manastonedrums.com/collections/9-note-classics/products/d-big-bear-manastone-steel-tongue-drum", // 	D Big Bear Scale
"https://manastonedrums.com/collections/9-note-classics/products/d-peace-manastone-steel-tongue-drum", //	D Peace Scale
"https://manastonedrums.com/pages/custom-steel-tongue-drums", //Custom scale   - must always be 15
"https://manastonedrums.com/pages/custom-steel-tongue-drums", //Custom - must always be 16
"https://manastonedrums.com/collections/9-note-classics/products/d-melog-manastone-steel-tongue-drum", //D Melog Scale
"https://manastonedrums.com/collections/9-note-classics/products/e-peace-manastone-steel-tongue-drum",  //E Peace scale
"https://manastonedrums.com/products/f-ngoni-manastone-steel-tongue-drum", //F N'Goni 
"https://manastonedrums.com/collections/9-note-classics/products/9-tongue-e-flat-lyanna-scale-manastone-steel-tongue-drum", // Eb Lyanna 
"https://manastonedrums.com/products/9-note-pentatonic-scales-manastone-steel-tongue-drums", //F minor Pentatonic
"https://manastonedrums.com/products/9-note-pentatonic-scales-manastone-steel-tongue-drums", //F Major Pentatonic
"https://manastonedrums.com/products/9-note-pentatonic-scales-manastone-steel-tongue-drums", //E Major Pentatonic
"https://manastonedrums.com/products/9-note-pentatonic-scales-manastone-steel-tongue-drums", //Eb minor Pentatonic
"https://manastonedrums.com/products/9-note-pentatonic-scales-manastone-steel-tongue-drums", //Eb Major Pentatonic
"https://manastonedrums.com/products/9-note-pentatonic-scales-manastone-steel-tongue-drums", //D Major Pentatonic
"https://manastonedrums.com/products/9-note-pentatonic-scales-manastone-steel-tongue-drums", //D minor Pentatonic
"https://manastonedrums.com/products/9-note-pentatonic-scales-manastone-steel-tongue-drums", //Db Major Pentatonic
"https://manastonedrums.com/products/9-note-pentatonic-scales-manastone-steel-tongue-drums", //Db minor Pentatonic
"https://manastonedrums.com/products/9-note-pentatonic-scales-manastone-steel-tongue-drums", //C Major Pentatonic
"https://manastonedrums.com/products/9-note-pentatonic-scales-manastone-steel-tongue-drums", //C minor Pentatonic
"https://manastonedrums.com/products/9-note-pentatonic-scales-manastone-steel-tongue-drums", //B Major Pentatonic
"https://manastonedrums.com/products/9-note-pentatonic-scales-manastone-steel-tongue-drums", //B minor Pentatonic
"https://manastonedrums.com/products/9-note-pentatonic-scales-manastone-steel-tongue-drums", //Bb Major Pentatonic
"https://manastonedrums.com/products/9-note-pentatonic-scales-manastone-steel-tongue-drums", //Bb minor Pentatonic
"https://manastonedrums.com/products/9-note-pentatonic-scales-manastone-steel-tongue-drums", //A Major Pentatonic
"https://manastonedrums.com/products/9-note-pentatonic-scales-manastone-steel-tongue-drums", //A minor Pentatonic
"https://manastonedrums.com/products/9-note-pentatonic-scales-manastone-steel-tongue-drums", //Ab Major Pentatonic
"https://manastonedrums.com/products/9-note-pentatonic-scales-manastone-steel-tongue-drums", //Ab minor Pentatonic
"https://manastonedrums.com/products/9-note-pentatonic-scales-manastone-steel-tongue-drums", //G Major Pentatonic 
"https://manastonedrums.com/products/9-note-pentatonic-scales-manastone-steel-tongue-drums", //G minor Pentatonic
"https://manastonedrums.com/products/9-note-pentatonic-scales-manastone-steel-tongue-drums", //Gb Major Pentatonic
"https://manastonedrums.com/products/9-note-pentatonic-scales-manastone-steel-tongue-drums", //Gb minor Pentatonic
"https://manastonedrums.com/products/9-note-ngoni-scales-manastone-steel-tongue-drums",		 //E N'Goni
"https://manastonedrums.com/products/9-note-ngoni-scales-manastone-steel-tongue-drums",  	 //D N'Goni
"https://manastonedrums.com/products/9-tongue-e-flat-lyanna-scale-manastone-steel-tongue-drum",//F Lyanna 9-note
"https://manastonedrums.com/products/9-tongue-e-flat-lyanna-scale-manastone-steel-tongue-drum",//E Lyanna 9-note
"https://manastonedrums.com/products/9-tongue-e-flat-lyanna-scale-manastone-steel-tongue-drum",//D Lyanna
"https://manastonedrums.com/products/9-note-melog-steel-tongue-drums",						 //E Melog
"https://manastonedrums.com/products/9-note-melog-steel-tongue-drums",  					 //F Melog
"https://manastonedrums.com/products/9-note-peace-scales-manastone-steel-tongue-drums",		 //Eb Peace
"https://manastonedrums.com/products/9-note-mixotonic-scales-manastone-steel-tongue-drums", //Eb Mixotonic
"https://manastonedrums.com/products/9-note-mixotonic-scales-manastone-steel-tongue-drums",  //D Mixotonic
  
];*/


var scale_product_links = [   
"https://manastonedrums.com/collections/9-note-classics/products/f-mixotonic", //	F Mixotonic Scale  - 0
"https://manastonedrums.com/collections/9-note-classics/products/f-big-bear", //	F Big Bear Scale
"https://manastonedrums.com/collections/9-note-classics/products/f-peace", //	F Peace Scale
"https://manastonedrums.com/collections/9-note-classics/products/e-big-bear-manastone-steel-tongue-drum", //	E Big Bear Scale
"https://manastonedrums.com/collections/9-note-classics/products/e-mixotonic-manastone-steel-tongue-drum", //	E Mixotonic Scale
"https://manastonedrums.com/collections/9-note-classics/products/e-akebono-9-note-steel-tongue-drum", //	E AkeBono Scale
"https://manastonedrums.com/collections/9-note-classics/products/e-phrygian-dominant-manastone-steel-tongue-drum", //	E Phrygian Dominant
"https://manastonedrums.com/collections/9-note-classics/products/e-minor-pentatonic-manastone-steel-tongue-drum", // 	E Minor Pentatonic
"https://manastonedrums.com/collections/9-note-classics/products/spanish-gypsy", //	Spanish Gypsy 
"https://manastonedrums.com/collections/9-note-classics/products/e-peace-manastone-steel-tongue-drum",  //E Peace scale
"https://manastonedrums.com/products/f-ngoni-manastone-steel-tongue-drum", //F N'Goni 
"https://manastonedrums.com/products/9-note-pentatonic-scales-manastone-steel-tongue-drums", //F minor Pentatonic
"https://manastonedrums.com/products/9-note-pentatonic-scales-manastone-steel-tongue-drums", //F Major Pentatonic
"https://manastonedrums.com/products/9-note-pentatonic-scales-manastone-steel-tongue-drums", //E Major Pentatonic
"https://manastonedrums.com/products/9-note-pentatonic-scales-manastone-steel-tongue-drums", //Db minor Pentatonic
"https://manastonedrums.com/products/9-note-pentatonic-scales-manastone-steel-tongue-drums", //A Major Pentatonic
"https://manastonedrums.com/products/9-note-pentatonic-scales-manastone-steel-tongue-drums", //Gb minor Pentatonic
"https://manastonedrums.com/products/9-note-ngoni-scales-manastone-steel-tongue-drums",		 //E N'Goni
"https://manastonedrums.com/products/9-tongue-e-flat-lyanna-scale-manastone-steel-tongue-drum",//F Lyanna 9-note
"https://manastonedrums.com/products/9-tongue-e-flat-lyanna-scale-manastone-steel-tongue-drum",//E Lyanna 9-note
"https://manastonedrums.com/products/9-note-melog-steel-tongue-drums",						 //E Melog
"https://manastonedrums.com/products/9-note-melog-steel-tongue-drums",  					 //F Melog
"https://manastonedrums.com/products/9-note-manastone-peak-custom-steel-tongue-drums",  					 //C major - kids
"https://manastonedrums.com/products/9-note-manastone-peak-custom-steel-tongue-drums",  					 //G spanish gypsy
"https://manastonedrums.com/products/9-note-manastone-peak-custom-steel-tongue-drums",  					 //G big bear
"https://manastonedrums.com/products/9-note-manastone-peak-custom-steel-tongue-drums",  					 //G mixotonic
"https://manastonedrums.com/products/9-note-pentatonic-scales-manastone-steel-tongue-drums", //G Major Pentatonic 
"https://manastonedrums.com/products/9-note-pentatonic-scales-manastone-steel-tongue-drums", //G minor Pentatonic
"https://manastonedrums.com/products/9-note-pentatonic-scales-manastone-steel-tongue-drums", //A minor Pentatonic
"https://manastonedrums.com/products/9-note-pentatonic-scales-manastone-steel-tongue-drums", //D Major Pentatonic
"https://manastonedrums.com/products/9-note-pentatonic-scales-manastone-steel-tongue-drums", //D minor Pentatonic
"https://manastonedrums.com/products/9-note-manastone-peak-custom-steel-tongue-drums",  					 //E pygmy
"https://manastonedrums.com/products/9-note-manastone-peak-custom-steel-tongue-drums",  					 //E aeolian
"https://manastonedrums.com/products/9-note-manastone-peak-custom-steel-tongue-drums",  					 //Eb Hijaz
"https://manastonedrums.com/pages/custom-steel-tongue-drums", //Custom scale
];
  
var tener_scale_product_links = [
"https://manastonedrums.com/collections/10-note-mana-drums/products/new-d-super-pygmy-manastone-steel-tongue-drum", //	D Super Pygmy Scale
"https://manastonedrums.com/collections/10-note-mana-drums/products/kurd-10-chameleon-cherry-steel-tongue-drum", //	D Kurd 10 Scale
"https://manastonedrums.com/collections/10-note-mana-drums/products/aeolian-10-manastone-steel-tongue-drum", // 	D Aeolian Scale
  ]

var using_scale_number = 0;
var eighteener_scale = -1;
var use_eighteener_scale = false;
var old_using_scale_number = 0;

function scale_select(x) {
	
	return scale_select_real(parseInt(x.value));
}

function scale_select_real(new_scale_value) {
	
	toggle_custom_scale(using_scale_number, new_scale_value);
	
	using_scale_number = new_scale_value;
	
	draw_scale_numbers(true);
	
	stage.update();
	
	updateDrumDescription();
    updateVisitProductButton();
	
	return false;
}

function eighteener_scale_select(x) {
	
	return eighteener_scale_select_real(parseInt(x.value));
	
}
function eighteener_scale_select_real(new_scale_value) {
	
	eighteener_scale = new_scale_value;
	
	if(new_scale_value == 16)
		show_custom_scale(1);
	else hide_custom_scale(1, using_scale_number);
	
	draw_scale_numbers(true);
	
	stage.update();
	
	updateDrumDescription();
	updateVisitProductButton();
	return false;
}

function toggle_custom_scale(x, y)
{
	if((x == 34 && y != 34) || (y == 34 && x != 34))
	{
		if( y==34 )
		{
			show_custom_scale(0);
			
		}
		else 
		{
			hide_custom_scale(0, -1);
		}
	}
}

function set_id_display(idx, displayx) {
	
	document.getElementById(idx).style.display = displayx;
	
}

function show_custom_scale(x)
{
	showing_custom_scale = true;
	
	if(x == 0)
		set_id_display("customScaleOne", 'block');
	
	if(x == 1)
		set_id_display("customScaleTwo", 'block');
	
	set_id_display("notesListing", 'block');
}

function hide_custom_scale(x, y)
{
	
	if(x == 0)
		set_id_display("customScaleOne", 'none');
	
	if(x == 1)
		set_id_display("customScaleTwo", 'none');
	
	if(eighteener_scale != 16 && y != 15)
	{
		set_id_display("notesListing", 'none');
		showing_custom_scale = false;
	}
}

function add_to_price(x) {
	
	var total = x + price;
	
	update_price( total );
}

function subtract_from_price(x) {
	var total = price - x;
	
	update_price( total );
}

function set_inner_html(idx, htmx) {
	document.getElementById(idx).innerHTML = htmx;
}

function update_price(x) {
	
	price = x;
	
	set_inner_html("priceTag", ("$" + price));
}

function adjust_drum_cost(x) {
	
	var new_drum_cost = x - drum_cost;
	drum_cost = x;
	
	add_to_price(new_drum_cost);
	
}

function drum_type_select(x) {
	
	drum_type_select_real(parseInt(x.value));
}

function drum_type_select_real(x) {
	
	var drum_num = x;
	
	if(drum_num != drum_type) {
		
		if ( // drum type changed to or from 10er
			(drum_num == 10 && drum_type != 10) ||
			(drum_type == 10 && drum_num != 10)
		) {
			
			if(drum_num == 10){
				
				stage.addChild(tener_button_image);
				
				hide_custom_scale(0, old_using_scale_number);
				
				hide_custom_scale(1, old_using_scale_number);
			}
			else {
				
				stage.removeChild(tener_button_image);
				
				if(drum_num == 9)
				{	
					hide_custom_scale(1, old_using_scale_number);
				}
				
				if( old_using_scale_number == 15 )
					show_custom_scale(0);
				
				if( old_using_scale_number == 16 )
					show_custom_scale(1);
			}
			
			var scale_switcher = old_using_scale_number;
			old_using_scale_number = using_scale_number;
			using_scale_number = scale_switcher;
			
			pat_select(using_pattern, drum_num);
			
			drum_type = drum_num;
			
			draw_scale_numbers(true);
			
			stage.update();
		}
	}
	
	drum_type = drum_num;
	
	if(drum_type == 9) {
		
		adjust_drum_cost(250);
		
		select_niner_drum();
	}
	if(drum_type == 10) {
		
		adjust_drum_cost(275);
		
		select_tener_drum();
		
	}
	if(drum_type == 18) {
		
		adjust_drum_cost(350);
		
		select_eighteener_drum();
		
	}
	if(drum_type == 99) {
		
		adjust_drum_cost(999);
		
		select_niner_drum();
	}
	
	updateDrumDescription();
    updateVisitProductButton();
}

function set_display_block(idx) {
	document.getElementById(idx).style.display = 'block';
}

function set_display_none(idx) {
	document.getElementById(idx).style.display = 'none';
}

function set_visibility_hidden(idx) {
	document.getElementById(idx).style.visibility = 'hidden';
}

function set_visibility_visible(idx) {
	document.getElementById(idx).style.visibility = 'visible';
}

function default_drum_style() {
	
	set_display_block("niner-scales");
	set_display_none("tener-scales");
}

function hide_eighteener() {
	
	set_visibility_hidden("p-eighteener-scales");
	set_visibility_hidden("eighteener-scales");
	
	set_display_none("p-eighteener-scales");
	set_display_none("eighteener-scales");
}

function select_niner_drum() {
	
	default_drum_style();
	
	hide_eighteener();
}

function select_tener_drum() {
	
	set_display_block("tener-scales");
	set_display_none("niner-scales");
	
	hide_eighteener();
}

function select_eighteener_drum() {
	
	default_drum_style();
	
	set_visibility_visible("p-eighteener-scales");
	set_visibility_visible("eighteener-scales");
  
  
	set_display_block("p-eighteener-scales");
	set_display_block("eighteener-scales");
	
	pickup_system = false;
	
}

function toggle_price(x, y, item, ammount) {
	
	if ( x == item && y != item ) {
		add_to_price( ammount );
	}
	if ( y == item &&  x != item ) {
		subtract_from_price( ammount );
	}
}

function cost_of_pattern(x) {
	
	if( x == "3" )
		return 100;
	
	if( x == "4" || x == "5" || x=="6")
		return 40;
	
	return 0;
}

function pattern_select(x) {
	
	pat_select(x.value, drum_type);
}

function pat_select(x, new_drum_type) {
	
	var n_price = cost_of_pattern(x);
	
	var price_difference = n_price - cost_of_pattern(using_pattern);
	
	if( price_difference != 0 )
		add_to_price(price_difference);
	
	change_drum_image(x, new_drum_type);
	
	var nFinName = "Finish: " + finish_names[x];
	
	updateDrumDescription();
}

function change_drum_image(new_image, new_drum_type) {
	
	var real_new_image = new_image;
	
	// Silver/copper, change when have image
	//if( new_image == 4)
	//	new_image = 2;
	
	// black/copper, change when have image
	//if( new_image == 5)
	//	new_image = 2;
	
	// black/silver, change when have image
	//if( new_image == 6)
	//	new_image = 1;
	
	if (drum_type == 10)
	{
		stage.removeChild(tener_images[using_pattern]);
	}
	else
	{
		stage.removeChild(niner_images[using_pattern]);
	}
	
	using_pattern = real_new_image;
	
	if (new_drum_type == 10){
		stage.addChild(tener_images[new_image]);
	}
	else // drum size 9
	{
		stage.addChild(niner_images[new_image]);
	}
	
	draw_scale_numbers(false);
	
	stage.update();
	
}

function getScalePosition(x) {
	
	for(var i = 0; i < drum_notes.length; i++) {
		if ( drum_notes[i] == x)
			return i;
	}
	
	return -1;
}

function get_num_notes() {
	
	if(drum_type == 10)
		return 10;
	
	return 9;
}

function draw_scale_numbers(update_scales) {
	
	var num_notes = get_num_notes();
	
	var msg = "";
	var note_pos;
	var actual_note;
	
	for(i=0;i<scale_display_text.length;i++)
	{
		
		// shouldnt execute if nothing in scale display text
		stage.removeChild(scale_display_text[i]);
	}
	
	if(update_scales)
	{
	
		scale_display_text = [];
		
		for(i=0;i<num_notes;i++)
		{
			
			actual_note = get_real_note(i);
			
			if(i==9 || actual_note == "?")
				msg = "";
			else {
				if(actual_note.length == 3)
					msg = "  ";
				else msg = " ";
			}
			
          if(drum_type == 10 && i==9){
            msg += "0" + "\n" + actual_note;
          }else{
            msg += (i+1) + "\n" + actual_note;
          }
			
			
          if(smallDrum){
            var text = new createjs.Text(msg, "10px Arial", "#fff");
          }else{
            var text = new createjs.Text(msg, "20px Arial", "#fff");
          }
			
			
          if(drum_type == 10){
            note_pos = i+1;
            if(i==9){
             note_pos = 0; 
            }
          }else{
            note_pos = i+1;
          }
			text.x = drum_note_positions[note_pos][0];
			text.y = drum_note_positions[note_pos][1];
          
          if(smallDrum){
            text.x = Math.floor(text.x / 2 );
            text.y = Math.floor(text.y / 2 );
          }
			 if(drum_type == 10 && i==9){
             	scale_display_text.unshift(text);
             }else{
            	scale_display_text.push(text);   
             }
			
		}
		
	}
	
	for(i=0;i<scale_display_text.length;i++)
	{
		stage.addChild(scale_display_text[i]);
	}
	
}

function custom_scale_postion_legal ( scaleNote, scalePosition, scale_to_use ) {
	console.log("Check note position scaleNote "+scaleNote + " scaleposition "+scalePosition + " scale to use "+scale_to_use);
	if(scale_to_use == -1)
		return false;
	
	var scale_to_test = scale_notes[scale_to_use];
	var n_note;
	var nnp;
	var snp;
	var note_ok;
  
  console.log("scale to test", scale_to_test);
	
	for(var i = 0; i < scale_to_test.length; i++) {
		
		
		n_note = scale_to_test[i];
		
		if( n_note != "?" && i != scalePosition)
		{
			
			nnp = getScalePosition(n_note);
			snp = getScalePosition(scaleNote);
          console.log("n_note : ",n_note);
          console.log(" nnp "+nnp);
          console.log(" snp "+snp);
			
			if(nnp == snp)
			{
				alert("Problem: scale note " + scaleNote + " cannot repeat.");
				return false;
			}
			
			if(i > scalePosition)
				note_ok = nnp > snp;
			else
				note_ok = nnp < snp;
			
			if(!note_ok)
			{
				var note_failure_msg = "Notes cannot decend as scale ascends.\n";
				if(i > scalePosition)
					note_failure_msg += "Problem: scale note " + n_note + " is less than " + scaleNote; 
				else 
				alert(note_failure_msg);
				return false;
			}
			
		}
	}
	
	return true;
}

function custom_scale_position_select( scaleNum, scalePosition ){
	
	var spos = parseInt(scalePosition)-1;
	
	var elementToHeilight = "csp";
	
	var scale_to_use = 1;
	
	if( scaleNum == 0) // Custom scale 1
	{
		scale_to_use = 34;
	}
	else {
		
		elementToHeilight = "cspx";
		
		scale_to_use = 16;
	}
	
	if(custom_scale_postion_legal ( prior_custom_scale_note, spos, scale_to_use))
	{
		scale_notes[scale_to_use][spos] = prior_custom_scale_note;
		
		document.getElementById(elementToHeilight + scalePosition).innerHTML = prior_custom_scale_note;
		
		createjs.Sound.play( prior_custom_scale_note, createjs.Sound.INTERRUPT_ANY );
		
		draw_scale_numbers(true);
		
		stage.update();
		
		updateDrumDescription();
        updateVisitProductButton();
	}
}

function custom_scale_note_select( scaleNote ){
	
	if(scaleNote != prior_custom_scale_note)
	{
		document.getElementById("csn"+prior_custom_scale_note).className = "";
		
		document.getElementById("csn"+scaleNote).className = "tableChosen";
		
		prior_custom_scale_note = scaleNote;
		
		createjs.Sound.play( scaleNote, createjs.Sound.INTERRUPT_ANY );
	}
}

function hit_with_select(x) {
	
	hit_with_select_real(x.value);
}

function hit_with_select_real(x) {
	
	if (x == "0")
	{
		hit_with = "F";
	}
	else {
		hit_with = "M";
	}
}

function do_cost_of_toggle(item, x) {
	
	if(item) {
		subtract_from_price(x);
	}
	else {
		add_to_price(x);
	}
}

function toggle_tuning(x) {
	
	toggle_tuning_real(x.value);
}

function toggle_tuning_real(x) {
	
	if (x == "0")
	{
		tuning = "440hz";
	}
	else {
		tuning = "432hz";
	}
	
	updateDrumDescription();
}

function toggle_use_eighteen(x) {
	
	if(eighteener_scale == -1)
		eighteener_scale = 0;
	use_eighteener_scale = !use_eighteener_scale;
	
	draw_scale_numbers(true);
	
	stage.update();
}

function toggle_pickup_system(x) {
	
	do_cost_of_toggle(pickup_system, 40);
	pickup_system = !pickup_system;
	
	if(!stock_drum) {
		if(pickup_system)
		{
			set_clock_image("clock5.png");
		}
		else {
			set_clock_image("clock4.png");
		}
	}
	
	updateDrumDescription();
}

function toggle_dampening_pads(x) {
	
	do_cost_of_toggle(dampening_pads, 20);
	dampening_pads = !dampening_pads;
	
	updateDrumDescription();
}


var playing_note = -1;

function keyboard_drum_note(x){
	
	new_stop = get_date_ms();
	
	if ((new_stop - keyboard_sound_delay) > sound_stops[x])
	{
		sound_stops[x] = new_stop;
		
		drum_note(x);
	}
}

function get_real_note(x) {
  //console.log("Get real note", x);
	
	if ( drum_type == 10 || x != 9 )
	{
		if( drum_type != 10 ) {
			
			if(drum_type == 18 && use_eighteener_scale)
			{
				return scale_notes[eighteener_scale][x];
			}
			else 
			{
				return scale_notes[using_scale_number][x];
			}
		}
		else // 10 note drum
		{
			
			// Account for fact that scale is shifted to middle note first on tener drum
			if (x == 9)
				x=0;
			else x++;
			
          //console.log("new x", x);
          //console.log(tener_scale_notes[using_scale_number][x]);
			return tener_scale_notes[using_scale_number][x];
		}
	}
	
	return "";
}

function determine_note(x) {
	
	var note_to_play = get_real_note(x);
	
	if( hit_with == "M" ) {
		note_to_play += "M";
	}
		
	return note_to_play;
	
}

function drum_note(x) {
	
	createjs.Sound.play( determine_note(x), createjs.Sound.INTERRUPT_ANY );
}

function play_note(x, y) {
	
	var c_minmax = [];
	
	for(var i = 0; i < niner_coordinates.length; i++) {
		c_minmax = niner_coordinates[i];
      if(smallDrum){
        if( x > Math.floor(c_minmax[0] / 2) && x < Math.floor(c_minmax[1] / 2) && y > Math.floor(c_minmax[2] / 2) && y < Math.floor(c_minmax[3] / 2) ){
			drum_note(i);
		}
        
      }else{
        if( x > c_minmax[0] && x < c_minmax[1] && y > c_minmax[2] && y < c_minmax[3] ){
			drum_note(i);
		}
        
      }

	}
	
	
	playing_note = -1;
}

function set_clock_image(x) {
	
	document.getElementById("clockImg").src="https://steeltonguedrums.com/images/" + x;
	
}

function copyToClipboard(pprompt, text) {
	window.prompt(pprompt, text);
}

function make_share_code() {
	
	var share_code = 
		"https://steeltonguedrums.com/play-and-buy/?"+ 
		"dt=" + drum_type + 
		"&sc=" + using_scale_number +
		"&fn=" + using_pattern;
	
	if(drum_type == 18) {
		share_code += "&sce=" + eighteener_scale;
	}
	
	if(hit_with == "M")
		share_code += "&hw=m";
	
	if(dampening_pads)
		share_code += "&rd=y";
	
	if(tuning == "432hz")
		share_code += "&tn=a";
	
	if(pickup_system)
		share_code += "&pps=y";
	
	var pprompt =
		"This link will direct your friends to this drum!\n" + 
		"To copy it to clipboard: Ctrl+C, Enter";
	
	updateDrumDescription();
	
	copyToClipboard( pprompt, share_code );
}

function drawDrum() {
  
            
    var canvas = document.getElementById("drumCanvas");
  if(smallDrum){
    canvas.width = 310;
  	canvas.height = 310;
  }else{
    canvas.width = 615;
  	canvas.height = 615;
  }

	
	stage = new createjs.Stage("drumCanvas");
	
	createjs.Touch.enable(stage);
	stage.enableMouseOver(10);
	stage.mouseMoveOutside = true;
  
   

    if(smallDrum){                                  
		
			
			tener_images.push(new createjs.Bitmap("//manastonedrums.com/cdn/shop/t/17/assets/peak_black_sm.png?v=153440740254850053961765972516"));
			niner_images.push(new createjs.Bitmap("//manastonedrums.com/cdn/shop/t/17/assets/peak_black_sm.png?v=153440740254850053961765972516"));

		
			
			tener_images.push(new createjs.Bitmap("//manastonedrums.com/cdn/shop/t/17/assets/peak_white_sm.png?v=117223823054129303691765972516"));
			niner_images.push(new createjs.Bitmap("//manastonedrums.com/cdn/shop/t/17/assets/peak_white_sm.png?v=117223823054129303691765972516"));

		
			
			tener_images.push(new createjs.Bitmap("//manastonedrums.com/cdn/shop/t/17/assets/peak_blue_sm.png?v=142687862599012743401765972516"));
			niner_images.push(new createjs.Bitmap("//manastonedrums.com/cdn/shop/t/17/assets/peak_blue_sm.png?v=142687862599012743401765972516"));

		
			
			tener_images.push(new createjs.Bitmap("//manastonedrums.com/cdn/shop/t/17/assets/peak_silver_sm.png?v=169704818775899407541765972516"));
			niner_images.push(new createjs.Bitmap("//manastonedrums.com/cdn/shop/t/17/assets/peak_silver_sm.png?v=169704818775899407541765972516"));

		
			
			tener_images.push(new createjs.Bitmap("//manastonedrums.com/cdn/shop/t/17/assets/peak_purple_sm.png?v=104966087321786446891765972516"));
			niner_images.push(new createjs.Bitmap("//manastonedrums.com/cdn/shop/t/17/assets/peak_purple_sm.png?v=104966087321786446891765972516"));

		
			
			tener_images.push(new createjs.Bitmap("//manastonedrums.com/cdn/shop/t/17/assets/peak_gold_sm.png?v=132464362940266040961765972516"));
			niner_images.push(new createjs.Bitmap("//manastonedrums.com/cdn/shop/t/17/assets/peak_gold_sm.png?v=132464362940266040961765972516"));

		
			
			tener_images.push(new createjs.Bitmap("//manastonedrums.com/cdn/shop/t/17/assets/peak_copper_sm.png?v=62169106042170941881765972516"));
			niner_images.push(new createjs.Bitmap("//manastonedrums.com/cdn/shop/t/17/assets/peak_copper_sm.png?v=62169106042170941881765972516"));

		
													
   }else{
		
			
			tener_images.push(new createjs.Bitmap("//manastonedrums.com/cdn/shop/t/17/assets/peak_black.png?v=96232265623462910181765972516"));
			niner_images.push(new createjs.Bitmap("//manastonedrums.com/cdn/shop/t/17/assets/peak_black.png?v=96232265623462910181765972516"));

		
			
			tener_images.push(new createjs.Bitmap("//manastonedrums.com/cdn/shop/t/17/assets/peak_white.png?v=17661127140716617591765972516"));
			niner_images.push(new createjs.Bitmap("//manastonedrums.com/cdn/shop/t/17/assets/peak_white.png?v=17661127140716617591765972516"));

		
			
			tener_images.push(new createjs.Bitmap("//manastonedrums.com/cdn/shop/t/17/assets/peak_blue.png?v=3801258202778695901765972516"));
			niner_images.push(new createjs.Bitmap("//manastonedrums.com/cdn/shop/t/17/assets/peak_blue.png?v=3801258202778695901765972516"));

		
			
			tener_images.push(new createjs.Bitmap("//manastonedrums.com/cdn/shop/t/17/assets/peak_silver.png?v=54981210434730053161765972516"));
			niner_images.push(new createjs.Bitmap("//manastonedrums.com/cdn/shop/t/17/assets/peak_silver.png?v=54981210434730053161765972516"));

		
			
			tener_images.push(new createjs.Bitmap("//manastonedrums.com/cdn/shop/t/17/assets/peak_purple.png?v=142972607651497837001765972516"));
			niner_images.push(new createjs.Bitmap("//manastonedrums.com/cdn/shop/t/17/assets/peak_purple.png?v=142972607651497837001765972516"));

		
			
			tener_images.push(new createjs.Bitmap("//manastonedrums.com/cdn/shop/t/17/assets/peak_gold.png?v=73938641259552456801765972516"));
			niner_images.push(new createjs.Bitmap("//manastonedrums.com/cdn/shop/t/17/assets/peak_gold.png?v=73938641259552456801765972516"));

		
			
			tener_images.push(new createjs.Bitmap("//manastonedrums.com/cdn/shop/t/17/assets/peak_copper.png?v=121439014662848133531765972516"));
			niner_images.push(new createjs.Bitmap("//manastonedrums.com/cdn/shop/t/17/assets/peak_copper.png?v=121439014662848133531765972516"));

		                                           
    }
	
	
		
/*

console.log("This is large drum");
  
    
    tener_images.push(new createjs.Bitmap("//manastonedrums.com/cdn/shop/t/17/assets/peak_black.png?v=96232265623462910181765972516"));
    niner_images.push(new createjs.Bitmap("//manastonedrums.com/cdn/shop/t/17/assets/peak_black.png?v=96232265623462910181765972516"));

  
    
    tener_images.push(new createjs.Bitmap("//manastonedrums.com/cdn/shop/t/17/assets/peak_white.png?v=17661127140716617591765972516"));
    niner_images.push(new createjs.Bitmap("//manastonedrums.com/cdn/shop/t/17/assets/peak_white.png?v=17661127140716617591765972516"));

  
    
    tener_images.push(new createjs.Bitmap("//manastonedrums.com/cdn/shop/t/17/assets/peak_blue.png?v=3801258202778695901765972516"));
    niner_images.push(new createjs.Bitmap("//manastonedrums.com/cdn/shop/t/17/assets/peak_blue.png?v=3801258202778695901765972516"));

  
    
    tener_images.push(new createjs.Bitmap("//manastonedrums.com/cdn/shop/t/17/assets/peak_silver.png?v=54981210434730053161765972516"));
    niner_images.push(new createjs.Bitmap("//manastonedrums.com/cdn/shop/t/17/assets/peak_silver.png?v=54981210434730053161765972516"));

  
    
    tener_images.push(new createjs.Bitmap("//manastonedrums.com/cdn/shop/t/17/assets/peak_purple.png?v=142972607651497837001765972516"));
    niner_images.push(new createjs.Bitmap("//manastonedrums.com/cdn/shop/t/17/assets/peak_purple.png?v=142972607651497837001765972516"));

  
    
    tener_images.push(new createjs.Bitmap("//manastonedrums.com/cdn/shop/t/17/assets/peak_gold.png?v=73938641259552456801765972516"));
    niner_images.push(new createjs.Bitmap("//manastonedrums.com/cdn/shop/t/17/assets/peak_gold.png?v=73938641259552456801765972516"));

  
    
    tener_images.push(new createjs.Bitmap("//manastonedrums.com/cdn/shop/t/17/assets/peak_copper.png?v=121439014662848133531765972516"));
    niner_images.push(new createjs.Bitmap("//manastonedrums.com/cdn/shop/t/17/assets/peak_copper.png?v=121439014662848133531765972516"));

  

*/
                                       
  	var queue = new createjs.LoadQueue(false);
	queue.on("complete", handleComplete);
      if(smallDrum){
		queue.loadFile({src:"//manastonedrums.com/cdn/shop/t/17/assets/buttons_niner_sm.png?v=10410953202071511171765972515", crossOrigin:true, id:"image_niner"});
    	queue.loadFile({src:"//manastonedrums.com/cdn/shop/t/17/assets/buttons_tener_sm.png?v=114043157607966341941765972515", crossOrigin:true, id:"image_tener"});        
      }else{
		queue.loadFile({src:"//manastonedrums.com/cdn/shop/t/17/assets/buttons_niner.png?v=92279133539483476231765972515", crossOrigin:true, id:"image_niner"});
    	queue.loadFile({src:"//manastonedrums.com/cdn/shop/t/17/assets/buttons_tener.png?v=99945937503567867581765972515", crossOrigin:true, id:"image_tener"});        
      }

                    
    		function handleComplete(event) {
    	            //console.log("Handle complete function", event);
                    
                    if(event.currentTarget._loadedResults.image_niner){
                    	//console.log("It's niner image");
                   	    var img = queue.getResult("image_niner");
	                	//console.log("IMG",img);
                		button_image = new createjs.Bitmap(img);
                    	button_image.cursor = "pointer";
                    
  	                    stage.addChild(button_image);
						//stage.addChild(blanking_image);
						stage.addChild(niner_images[0]);
	
	                    button_image.addEventListener("click", function(event){
    	               		play_note(event.stageX, event.stageY);
	                   	});
                    
                   		draw_scale_numbers(true);
  					}

					if(event.currentTarget._loadedResults.image_tener){
                      	//console.log("It's tener image");
                   	    var img = queue.getResult("image_tener");
	                	//console.log("IMG",img);
                		
                		tener_button_image = new createjs.Bitmap(img);
                    	tener_button_image.cursor = "pointer";
                      	tener_button_image.addEventListener("click", function(event){
                      		drum_note(9);
                      
                      	});
					}
			}
                              
	
	//if (!createjs.Sound.initializeDefaultPlugins()) {return;}
	// createjs.Sound.registerPlugins([createjs.WebAudioPlugin]);
	createjs.Sound.registerPlugins ([
		createjs.HTMLAudioPlugin, 
		createjs.WebAudioPlugin, 
		createjs.FlashPlugin 
	]);
	
	var sounds = [];
	for(var i = 0; i < drum_notes.length; i++) {
		n = drum_notes[i];
        var noteFile = drum_notes_files[i];
		sounds.push(
			{
				id:		n,
				src:	noteFile
			}
		);
	}
	
	for(var i = 0; i < drum_notes.length; i++) {
		n = drum_notes[i];
      	var noteFile = drum_notes_m_files[i];
		sounds.push(
			{
				id:		n+"M",
				src:	noteFile
			}
		);
	}
	
	//createjs.Sound.alternateExtensions = ["mp3"];
	//createjs.Sound.volume = 0.95;
	createjs.Sound.addEventListener("fileload", handleLoad);
	createjs.Sound.registerSounds(sounds, audioPath);
	function handleLoad(event) {
		
	}
	


	
	createjs.Ticker.addEventListener("tick", handleTick);
	
	function handleTick(event) {
		
		stage.update();
	}
	
	
	
	load_drum_url_data();
	
	updateDrumDescription();
	
}

function set_doc_id_value( idx, valuex) {
	document.getElementById(idx).value = valuex;
}

function load_drum_url_data() {
	
	var new_drum_type = getParameterByName('dt');
	
	if(new_drum_type) {
		
		if( getParameterByName('st') == "y" ) {
			stock_drum=true;
			
			set_clock_image("clock4.png");
		}
		
		var new_drum_scale = parseInt(getParameterByName('sc'));
		var new_drum_finish = getParameterByName('fn');
		
		if(new_drum_type == "10") {
			
			drum_type_select_real(10);
			
			set_doc_id_value( "tenerScaleSelect", new_drum_scale);
			
			set_doc_id_value( "drum-type-select", "10");
		}
		
		if(new_drum_type == "18") {
			
			drum_type_select_real(18);
			
			set_doc_id_value( "drum-type-select", "18");
		}
		
		if(new_drum_type == "9") {
			
			set_doc_id_value( "ninerScaleSelect", new_drum_scale);
		}
		
		pat_select(new_drum_finish, drum_type);
		
		scale_select_real(new_drum_scale);
		
		if(new_drum_type == "18") {
			
			set_doc_id_value( "ninerScaleSelect", new_drum_scale);
			
			var new_eighteener_scale = getParameterByName('sce');
			eighteener_scale_select_real(parseInt(new_eighteener_scale));
			
			set_doc_id_value( "eighteener-scale-select", new_eighteener_scale);
		}
		
		set_doc_id_value( "niner-finish-select", new_drum_finish);
		
		if( getParameterByName('hw') == "m" ) {
			document.getElementById('malletbutton').checked = true;
			document.getElementById('fingerbutton').checked = false;
			
			hit_with = "M";
		}
		
		if( getParameterByName('rd') == "y" ) {
			document.getElementById("padding-checkbox").checked = true;
			toggle_dampening_pads(0);
		}
		
		if( getParameterByName('tn') == "a" ) {
			document.getElementById('altTuning').checked = true;
			document.getElementById('stdTuning').checked = false;
			toggle_tuning(0);
		}
		
		if( getParameterByName('pps') == "y" ) {
			document.getElementById("pickup-checkbox").checked = true;
			toggle_pickup_system(0);
		}
	}
}

function getParameterByName(name) {
    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
        results = regex.exec(location.search);
    return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
}

function updateDrumDescription() {
	//Removed description block
	//set_inner_html("buyDrumDescription", getDescriptionMessage());
}
      
function updateVisitProductButton(){
	if(drum_type == 9 || drum_type == 18) {
      var product_url = scale_product_links[using_scale_number];
      var scale_name = scale_names[using_scale_number];
    }
  
  if(drum_type == 10) {
    var product_url = tener_scale_product_links[using_scale_number];
    var scale_name = tener_scale_names[using_scale_number];
  }
  
  if(drum_type == 18){
	var product_url = "https://manastonedrums.com/collections/18-note-double-sided-steel-tongue-drums";
    var scale_name = "18 Note Double Sided Manastone";
  }
  
	document.getElementById('visit_product_button').href = product_url;
    //document.getElementById('product-button-scale-name').innerHTML = scale_name;
  var part1 = scale_name.split(" ")[0];
  var part2 = scale_name.replace(part1, "");
  part2 = part2.trim();
  document.getElementById('product-button-scale-name_part1').innerHTML = part1;
  document.getElementById('product-button-scale-name_part2').innerHTML = part2;
  


}

function showCustomScale(x) {
	
	var scale_t = 'the Custom Scale: "';
	
	for(var i = 0; i < 9; i++) {
		scale_t += scale_notes[34][i];
		
		if( i != 8 )
			scale_t += " ";
	}
	
	scale_t += '"';
	
	return scale_t;
}


function get_eighteen_scale_name() {
	if(eighteener_scale == -1)
		return scale_names[0];
	else {
		return scale_names[eighteener_scale];
	}
}

function getDescriptionMessage() {
	
	var ret = "";
	
	var scale_t = "the " + scale_names[using_scale_number];
	if(using_scale_number == 34) {
		scale_t = showCustomScale(34);
	}
	
	var STD = " Steel Tongue Drum";
	var d_name = "";
	
	if(drum_type == 9) {
		
		d_name = "Cloud Nine Series" + STD;
		
		ret += d_name + " ($250)";
	}
	
	if(drum_type == 18) {
		
		d_name = "18 Note Double Sided" + STD;
		
		ret += d_name + " ($350)";
		
		//Custom scale
		if( eighteener_scale == 18) {
			scale_t += " and " + showCustomScale(18);
		}
		else { // Not custom scale
			
			scale_t += " and the " + get_eighteen_scale_name();
		}
	}
	
	if(drum_type == 10) {
		
		d_name = "Mana Drum Series" + STD;
		
		ret += d_name + " ($275)";
		
		scale_t = tener_scale_names[using_scale_number];
	}
	
	ret += " in " + finish_names[using_pattern];
	
	var fncost = cost_of_pattern(using_pattern);
	if(fncost)
		ret += " ($" + fncost + ")";
	
	ret += " using " + scale_t;
	
	if(tuning != "440hz")
		ret += " tuned to 432hz";
	
	if(dampening_pads)
		ret += " with rubber dampening pads ($20)";
	
	if(pickup_system)
		ret += " and with the Piezo pickup system ($40)";
		
	ret += ".";
	
	return ret;
}

function update_email() {
	updateDrumDescription();
}

function post_to_url(path, params, method) {
    method = method || "post";

    var form = document.createElement("form");

    //Move the submit function to another variable
    //so that it doesn't get overwritten.
    form._submit_function_ = form.submit;

    form.setAttribute("method", method);
    form.setAttribute("action", path);

    for(var key in params) {
        var hiddenField = document.createElement("input");
        hiddenField.setAttribute("type", "hidden");
        hiddenField.setAttribute("name", key);
        hiddenField.setAttribute("value", params[key]);

        form.appendChild(hiddenField);
    }

    document.body.appendChild(form);
    form._submit_function_(); //Call the renamed function.
}

function add_to_cart() {
	
	var productID = 0;
	var variationID = 0;
	var varIDS = [];
	var postURL = '/cart';
	
	var tagPickups = "None";
	if(pickup_system)
		tagPickups = "Piezo";
	
	var tagDamping = "None";
	if(dampening_pads)
		tagDamping = "Rubber";
	
	var tagScale = scale_names[using_scale_number];
	// fix custom scale!
	
	var tagFinish = finish_names[using_pattern];
	
	if(drum_type == 9) {
		
		productID = 909;
		
		if(pickup_system) {
			
			if(dampening_pads) {
				varIDS = [ 930, 932, 931, 933, 934, 935, 936 ];
			}
			else {
				varIDS = [ 937, 939, 938, 940, 941, 942, 943 ];
			}
		}
		else {
			
			if(dampening_pads) {
				varIDS = [ 923, 925, 924, 926, 927, 928, 929 ];
			}
			else {
				varIDS = [ 913, 915, 914, 910, 916, 917, 918 ];
			}
		}
		
		variationID = varIDS[using_pattern];
	}
	
	if(drum_type == 18) {
		
		productID = 945;
		
		var tagScaleSecond = get_eighteen_scale_name();
		
		if(pickup_system) {
			
			if(dampening_pads) {
				varIDS = [ 959, 957, 958, 956, 955, 954, 953 ];
			}
			else {
				varIDS = [ 952, 950, 951, 949, 948, 947, 946 ];
			}
		}
		else {
			
			if(dampening_pads) {
				varIDS = [ 966, 964, 965, 963, 962, 961, 960 ];
			}
			else {
				varIDS = [ 972, 970, 971, 973, 969, 968, 967 ];
			}
		}
		
		variationID = varIDS[using_pattern];
		
		post_to_url(
				postURL, 
				{ 
					attribute_finishes: tagFinish,
					attribute_scale: tagScale,
					"attribute_second-scale": tagScaleSecond,
					attribute_dampening: tagDamping,
					attribute_pickups: tagPickups,
					attribute_tuning: tuning,
					quantity: "1",
					"add-to-cart": productID,
					product_id: productID,
					variation_id: variationID
				}
		);
		
		return false;
	}
	
	if(drum_type == 10) {
		
		productID = 975;
		
		if(pickup_system) {
			
			if(dampening_pads) {
				varIDS = [ 989, 987, 988, 986, 985, 984, 983 ];
			}
			else {
				varIDS = [ 982, 980, 981, 979, 978, 977, 976 ];
			}
		}
		else {
			
			if(dampening_pads) {
				varIDS = [ 996, 994, 995, 993, 992, 991, 990 ];
			}
			else {
				varIDS = [ 1002, 1000, 1001, 1003, 999, 998, 997 ];
			}
		}
		
		tagScale = tener_scale_names[using_scale_number];
		
		variationID = varIDS[using_pattern];
	}
	
	post_to_url(
			postURL, 
			{ 
				attribute_finishes: tagFinish,
				attribute_scale: tagScale,
				attribute_dampening: tagDamping,
				attribute_pickups: tagPickups,
				attribute_tuning: tuning,
				quantity: "1",
				"add-to-cart": productID,
				product_id: productID,
				variation_id: variationID
			}
	);
	
	return false;
	
}
